export const TestHooks = {
	UpdatePinButton: 'update-pin-button',
	UpdateNoteDiv: 'update-note-div',
} as const;
